import React from 'react';
import Image from 'components/images';
import Text from 'components/outputs/Text';
import { View } from 'components/layout/View';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

export default function ConfigurationError() {
  const { t } = useTranslation();

  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.card}>
        <Image name={'error'} size={180} />
        <Text style={{ fontWeight: 700 }}>{t('error')}</Text>
        <View pv={1}>
          <Text>
            {t('this_app_is_temporarily_unavailable_please_try')}
          </Text>
        </View>
      </div>
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    width: '100%',
    height: '100vh',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  card: {
    maxWidth: 350,
    textAlign: 'center',
    backgroundColor: 'white',
    borderRadius: '15px',
    padding: theme.spacing(3),
  },
}));
